import { render } from "./Dashboard.vue?vue&type=template&id=fa2f68a6&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-fa2f68a6"

export default script